import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";
import styles from "./ActionForm.module.scss";

interface Props {
    index: number;
}

export const MemoActionForm: React.FC<Props> = ({ index }) => {
    const [field, , helpers] = useField<string>(`actions.${index}.value.memo`);

    return (
        <Form.Control
            {...field}
            className={styles.memoInput}
            type="text"
            onChange={(e) => helpers.setValue(e.target.value)}
            placeholder="Enter note"
            size="sm"
            style={{ minWidth: "240px" }}
        />
    );
};
